module.exports = __webpack_public_path__ + "Roboto-RegularItalic.df8e3a9b9aed94341797.woff2";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff2
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff2
// module chunks = 13